/** @format */

import template from './gb-edit-raffle-winners-widget.html';
import './gb-edit-raffle-winners-widget.scss';

export const GbEditRaffleWinnersWidgetComponent = {
    template,
    require: {
        gbApp: '^^',
        gbEditTools: '^^',
    },
    bindings: {
        widget: '=',
    },
    controller: class GbEditRaffleWinnersWidgetComponent {
        constructor($gbItem, $gbRaffleItem, $rootScope, $translate, $ccLoading, LoadingHelper) {
            'ngInject';

            this.$gbItem = $gbItem;
            this.$gbRaffleItem = $gbRaffleItem;
            this.$rootScope = $rootScope;
            this.$translate = $translate;

            this.loadingHelper = new LoadingHelper();
            this.isLoading = () => this.loadingHelper.isLoading();
            this.getLoadingMessage = () => this.loadingHelper.getFirstMessage();
            this.loadingWatcher = $ccLoading.bind(this.isLoading, this.getLoadingMessage);
        }

        getRaffleItems() {
            return this.$gbRaffleItem.cache.query({
                auction: this.gbApp.getAuctionUrl(),
            });
        }

        getItemById(itemId) {
            return this.$gbItem.cache.single(itemId);
        }

        showPreviewRaffleDraw() {
            let dummyDataLabel = this.$translate.instant('RAFFLE_PREVIEW_DUMMY_DATA_LABEL');

            let draw = {
                ticket_number: 999999,
                prize: 1,
                profile_name: dummyDataLabel,
            };
            this.$rootScope.$broadcast(this.gbApp.$raffleWinnerPreviewEvent, draw);
        }

        onRafleItemChange() {
            const loader = this.loadingHelper.push('SAVING');

            this.gbEditTools.saveWidget().finally(() => {
                loader();
            });
        }
    },
};
